import avatar1 from '../assets/images/users/user.jpg';

/**
 * Get user avatar with fallback to default
 * @param {string} photoUrl - User's photo URL
 * @returns {string} - Avatar URL or default avatar
 */
export const getUserAvatar = photoUrl => {
  // If photoUrl is null, undefined, or empty string, return default avatar
  if (!photoUrl || photoUrl.trim() === '') {
    return avatar1;
  }

  return photoUrl;
};

/**
 * Handle avatar image error and set fallback
 * @param {Event} event - Image error event
 */
export const handleAvatarError = event => {
  event.target.src = avatar1;
};
